import { Component, computed, ElementRef, viewChildren } from '@angular/core';
import { PropsServiceService } from '../../props-service.service';
import { KopConfigService } from '../../../core/kop-config.service';
import { FocusManagerService } from '../../../keynav/focus-manager.service';
import { BaseListComponent } from '../../../keynav/base-list/base-list.component';
import { BaseElementComponent } from '../../../keynav/base-element/base-element.component';
import { BijzPrgmsEditorComponent } from '../../bijz-prgms-editor/bijz-prgms-editor.component';

@Component({
  selector: 'klassiek-bijz-prgms',
  templateUrl: './klassiek-bijz-prgms.component.html',
  styleUrls: ['./klassiek-bijz-prgms.component.scss']
})
export class KlassiekBijzPrgmsComponent extends BaseListComponent {

  constructor(public propsService: PropsServiceService, public kopConfigService: KopConfigService,
    elementRef: ElementRef<HTMLElement>, focusManager: FocusManagerService) {
    super(elementRef, focusManager);
    this.keyProperty = "klassiek-bijz-prgms";
  }


  public availableBijzPrgms = computed(() => {
    let currentBPrgms = this.propsService.bijzPrgs();
    let bprgmsMetas = this.kopConfigService.currentMeta().bijzPrgs;
    let metas = bprgmsMetas.filter(bpm => !currentBPrgms.find(bp => bp.index == bpm.index));
    let ret = metas.map(m => {
      return this.kopConfigService.bijzPrgmKCtoModule(m.index, undefined);
    });
    return ret;
  });

  public bijzPrgmEditors = viewChildren(BijzPrgmsEditorComponent);
  public getChildren(): readonly BaseElementComponent[] {
    return this.bijzPrgmEditors();
  }

}
